import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	required: {
		id: 'jsd.project-settings-apps.issue-type-page.field.required',
		defaultMessage: 'Required',
		description: 'Label for checkbox marking a field as required; and lozenge in field card',
	},
});
